<template>
  <div v-if="false" class="askyou" id="askyou">
    <div>
      <van-form @submit="onSubmit" :show-error="false">
        <school-input @school-event="schoolEvent" />
        <van-field
          readonly
          clickable
          required
          label="班级"
          name="classpicker"
          :value="classInfo.text"
          placeholder="点击选择班级"
          @click="showClassPicker = true"
          :rules="[{ required: true, message: '选择宝贝所在班级' }]"
        />
        <van-popup v-model="showClassPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="classColumns"
            @cancel="showClassPicker = false"
            @confirm="onClassConfirm"
          />
        </van-popup>

        <van-field
          v-model="stuName"
          name="stuName"
          label="姓名"
          placeholder="请输入姓名"
          required
          :rules="[{ required: true, message: '请输入正确班级的姓名' }]"
        />
        <van-field
          v-model="stuID"
          name="stuID"
          label="学号"
          placeholder="请输入学号"
          required
          :rules="[{ required: true, message: '请输入学号' }]"
        />
        <div style="margin: 16px">
          <van-button round block native-type="submit" color="#4aaca2">
            查询食谱
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
  <!--  <div v-if="device">1</div>-->
  <div v-else class="login">
    <img class="login-form-bg" src="@/assets/login-bg.svg" />
    <div class="login-form">
      <div class="login-title">学校绑定</div>
      <div class="login-school">
        <van-cell
          title="所在地区"
          :value="areaValue"
          is-link
          clickable
          @click="handleChooseArea"
        />
      </div>
      <van-divider />
      <div>
        <van-cell
          title="学校名称"
          :value="schoolValue"
          is-link
          clickable
          @click="handleChooseSchool"
        />
      </div>
      <div class="login-button">
        <van-button color="#846FFE" round block @click="handleToHome"
          >绑定</van-button
        >
      </div>
      <div>{{ url }}</div>
    </div>
    <van-popup v-model="showArea" round position="bottom">
      <van-area
        title="选择区域"
        :area-list="areaList"
        @confirm="onConfirmArea"
        @cancel="showArea = false"
      >
      </van-area>
    </van-popup>
    <van-popup
      v-model="showSchool"
      closeable
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="school-popup">
        <div class="school-popup-header">学校名称</div>
        <div class="school-popup-input">
          <van-search
            v-model="searchValue"
            shape="round"
            @input="handleSearch"
            placeholder="请输入学校名称"
          />
        </div>
        <div class="school-popup-list">
          <template v-if="schoolList.length === 0">
            <div class="no-school">
              <img src="../../assets/chooseSchool/no-school.svg" alt="" />
              <p>暂无学校</p>
            </div>
          </template>
          <template v-else>
            <div
              v-for="item in schoolList"
              :key="item.id"
              @click="handleSelect(item)"
              class="van-hairline--bottom school-popup-title"
            >
              {{ item.tenantName }}
            </div>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// import schoolInput from "@/views/foods/components/SchoolInput.vue";
import { Toast } from "vant";
import { Notify, Dialog } from "vant";
import { mapState } from "vuex";
import { proviceList, findSchool, bindSchool } from "../../api/searchFoods";
// import { bindSchool} from '../../api/searchFoods'
export default {
  components: {
    // schoolInput,
  },
  data() {
    return {
      showArea: false, // 地区选择弹窗
      showSchool: false, // 选择学校弹窗
      areaValue: "请选择地区",
      schoolValue: "请选择学校",
      areaCode: 0, // 选中地区的code
      tenantId: 0, // 选中的学校id
      searchValue: "", // 搜索学校选项
      areaList: {}, // 省市区列表
      schoolList: [], // 学些列表
      stuName: "",
      stuID: "",
      classColumns: [],
      foodsList: {
        week1: [],
        week2: [],
        week3: [],
        week4: [],
        week5: [],
        week6: [],
        week7: [],
      },
      showClassPicker: false,
      classInfo: {
        text: "",
        id: "",
      },
      classInfoLast: "",
      schoolName: "",
      recipeDay: 5,
      device: false, // 判断是否是微信客户端
      url: null,
      logoUrl: "", // 学校头像
    };
  },
  computed: {
    ...mapState(["openId"]),
  },
  created() {
    this.getProviceList();
  },
  methods: {
    // 获取省市区列表
    async getProviceList() {
      const res = await proviceList();
      if (res.data.code === 200) {
        const result = res.data.data;
        const obj = {};
        const cityList = {};
        const districtNameList = {};
        result.forEach((ele) => {
          obj[ele.code] = ele.name;
          if (ele.children && ele.children.length !== 0) {
            ele.children.forEach((item) => {
              cityList[item.code] = item.cityName;
              if (item.children && item.children.length !== 0) {
                item.children.forEach((el) => {
                  districtNameList[el.code] = el.districtName;
                });
              }
            });
          }
        });
        this.areaList.province_list = obj;
        this.areaList.city_list = cityList;
        this.areaList.county_list = districtNameList;
        // Notify({type: 'success',message: '成功了!'})
      }
    },
    // 根据省市区查找学校
    async getSchoolList(code, tenantName) {
      const res = await findSchool(code, tenantName);
      if (res.data.code === 200) {
        this.schoolList = res.data.data;
      }
    },
    schoolEvent(values, schoolName) {
      this.classColumns = values;
      this.schoolName = schoolName;
    },
    onClassConfirm(value, index) {
      console.log(this.classColumns);
      console.log(value);
      console.log(index);
      if (value) {
        this.classInfoLast = value[value.length - 1];
        this.classInfo.text = value.join("/");
        var classColumns = this.classColumns;
        index.forEach((el) => {
          classColumns = classColumns[el];
          if (classColumns.children) {
            classColumns = classColumns.children;
          }
        });
        this.classInfo.id = classColumns.id;
        this.showClassPicker = false;
      }
    },
    onSubmit() {
      sessionStorage.classId = this.classInfo.id;
      sessionStorage.classText = this.classInfo.text;
      sessionStorage.stuName = this.stuName;
      sessionStorage.childNo = this.stuID;
      sessionStorage.classInfoLast = this.classInfoLast;
      sessionStorage.recipeDay = this.recipeDay;
      sessionStorage.schoolName = this.schoolName;
      var params = {
        classId: this.classInfo.id,
        name: this.stuName,
        childNo: this.stuID,
        classInfoLast: this.classInfoLast,
      };
      this.axios({
        url: "api/blade-food/recipe/vilateStudent",
        method: "post",
        data: params,
      })
        .then((res) => {
          // if (res.data.data.recipeCycles) {
          //   var val = res.data.data.recipeCycles;
          //   this.foodsList = weekforfoods(val);
          //   this.recipeDay = res.data.data.recipeDay;
          //   sessionStorage.tenantId = res.data.data.tenantId;
          //   sessionStorage.studentId = res.data.data.studentId;
          //   sessionStorage.recipeId = res.data.data.recipeCycles[0].recipeId;
          // }

          console.log(res);
          this.$router.push({ path: "/foodsInfo" });
        })
        .catch((err) => {
          alert(err);
          if (typeof err.response.data.msg === "string") {
            Notify({ type: "warning", message: err.response.data.msg });
          }
        });
    },
    onClickLeft() {
      //   Toast("返回");
      //   console.log("返回");
      this.$router.go(-1); //返回上一层
    },
    onClickRight() {
      Toast("按钮");
    },
    //选择地区
    handleChooseArea() {
      this.showArea = true;
    },
    // 确认地区
    onConfirmArea(values) {
      this.areaValue = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join(" ");
      this.areaCode = values[values.length - 1].code;
      this.showArea = false;
    },
    //选择学校
    handleChooseSchool() {
      if (this.areaValue === "请选择地区") {
        Dialog.alert({
          title: "您还未选择地区！",
          // message: "弹窗内容",
        }).then(() => {
          // on close
        });
        this.areaTips = true;
      } else {
        if (this.areaCode !== 0) {
          this.getSchoolList(this.areaCode, "");
          this.showSchool = true;
        }
      }
    },
    // 搜索学校
    handleSearch(e) {
      this.getSchoolList(this.areaCode, e);
    },
    // 确认选择学校
    handleSelect(e) {
      console.log(e);
      this.schoolValue = e.tenantName;
      this.tenantId = e.tenantId;
      this.logoUrl = e.logoUrl;
      this.$store.commit("setChooseSchool", {
        tenantName: e.tenantName,
        tenantId: e.tenantId,
      });
      localStorage.setItem(
        "teantObj",
        JSON.stringify({
          tenantName: this.schoolValue,
          tenantId: this.tenantId,
          tenantImg: this.logoUrl,
        })
      );
      this.showSchool = false;
    },
    // 绑定按钮
    handleToHome() {
      // this.$router.push({path: "/foodsInfo"});

      if (
        this.areaValue !== "请选择地区" &&
        this.schoolValue !== "请选择学校"
      ) {
        const data = {
          sysTenantId: this.tenantId,
          openId: this.openId,
					type: 1
        };
        bindSchool(data).then(() => {
          // if(res.data.code === 200){
          //   this.$router.push({ path: "/home" });
          // } else {
          //   Dialog.alert({
          //     title: res.data.msg,
          //   }).then(() => {
          //     // on close
          //   });
          // }
          this.$router.push({ path: "/home" });
        });
      } else if (this.areaValue === "请选择地区") {
        Dialog.alert({
          title: "您还未选择地区！",
          // message: "弹窗内容",
        }).then(() => {
          // on close
        });
      } else if (this.schoolValue === "请选择学校") {
        Dialog.alert({
          title: "您还未选择学校！",
          // message: "弹窗内容",
        }).then(() => {
          // on close
        });
      } else {
        console.log(
          this.tenantId,
          this.openId,
          this.areaValue,
          this.schoolValue
        );
      }

      // this.$router.push({ path: "/home" });
    },
  },
};
</script>

<style scoped>
.login {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background: linear-gradient(
    180deg,
    #252d40,
    #181e2c 10%,
    #161b29 34%,
    #f5f6f7 50%
  );
}
.van-divider {
  margin-left: 0.3rem;
  margin-right: 0.3rem;
}
/* .login-school{
  padding: 0.2rem 0;
  height: 2.4rem;
  box-sizing: border-box;
}
.login-school .van-cell{
  margin: 0.3rem 0;
} */
.login-form {
  padding-top: 0.5rem;
  margin: 0 0.2rem;
  margin-top: -0.6rem;
  height: 6.6rem;
  /*width: 100%;*/
  border-radius: 0.2rem;
  background-color: #fff;
  box-sizing: border-box;
}
.login-form-bg {
  margin-top: 2rem;
  margin-left: 0.6rem;
  width: 5rem;
  height: 3rem;
}
.login-title {
  margin-bottom: 0.5rem;
  font-size: 0.5rem;
  text-align: center;
  letter-spacing: 0.1rem;
  font-family: PingFangSC, PingFangSC-Regular;
}
.login-button {
  margin-top: 0.8rem;
  box-sizing: border-box;
  padding: 0 0.3rem;
  width: 100%;
}
.van-button__text {
  margin-left: 0.2rem;
  text-align: center;
  font-size: 0.4rem;
  letter-spacing: 0.2rem;
}
/*选择学校弹出框*/
.school-popup {
  height: calc(100% - 0.3rem);
}
.school-popup-header {
  margin-top: 0.3rem;
  height: 0.4rem;
  text-align: center;
}
.school-popup-input {
  height: 1rem;
}
.school-popup-list {
  padding: 0 0.25rem;
  height: calc(100% - 1.4rem);
  overflow-y: scroll;
}
.school-popup-title {
  padding: 0.2rem 0;
}
/* 暂无学校 */
.school-popup-list .no-school {
  margin-top: -0.5rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}
.school-popup-list .no-school img {
  width: 1.5rem;
  height: 1.5rem;
}
.school-popup-list .no-school p {
  margin-top: 0.1rem;
  width: 1.5rem;
}
</style>
